import { createContext, useContext, useState, useEffect, useCallback } from 'react';

const SidebarContext = createContext(null);

export function SidebarProvider({ children }) {
  const [collapsed, setCollapsed] = useState(() => {
    const stored = localStorage.getItem('sidebar_collapsed');
    return stored === null ? (window.innerWidth < 768) : stored === 'true';
  });

  // Persist to localStorage
  useEffect(() => {
    localStorage.setItem('sidebar_collapsed', String(collapsed));
  }, [collapsed]);

  // Set CSS custom properties for fixed navbar offset
  useEffect(() => {
    const mdWidth = collapsed ? '64px' : '224px';
    const lgWidth = collapsed ? '64px' : '256px';
    document.documentElement.style.setProperty('--sidebar-width-md', mdWidth);
    document.documentElement.style.setProperty('--sidebar-width-lg', lgWidth);
    document.documentElement.setAttribute('data-sidebar', collapsed ? 'collapsed' : 'expanded');
  }, [collapsed]);

  // Auto-collapse on mobile resize
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) setCollapsed(true);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggle = useCallback(() => setCollapsed(prev => !prev), []);

  return (
    <SidebarContext.Provider value={{ collapsed, setCollapsed, toggle }}>
      {children}
    </SidebarContext.Provider>
  );
}

export function useSidebar() {
  const ctx = useContext(SidebarContext);
  if (!ctx) return { collapsed: true, setCollapsed: () => {}, toggle: () => {} };
  return ctx;
}
